import React, { useState } from 'react';
import { shopVar } from '@/lib/shopStyles';
import clsx from 'clsx';
import { useCart } from '@/providers/CartProvider';
import { useLanguage } from '@/providers/LanguageProvider';
import { Money } from '@/lib/money';
import * as m from "@/paraglide/messages.js"

export const DiscountCodes: React.FC = () => {
    const { applyCoupon, removeCoupon, cart } = useCart();
    const { currentLanguage: lang } = useLanguage();

    const [discountCode, setDiscountCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const addDiscountCode = async () => {
        setLoading(true);
        setError('');
        const result = await applyCoupon(discountCode);
        if(result === true){
            setDiscountCode('');
        } else {
            setError(result);
        }

        setLoading(false);
    }

    const doRemoveCoupon = async () => {
        await removeCoupon();
    }

    return (
        <div className='pb-4'>
            {(cart === null || cart?.appliedCouponCode === undefined || cart.appliedCouponCode === null) && (
            <>
                <div className="flex items-center gap-x-2">
                {/* let the input grow and shrink inside flex */}
                <input
                    type="text"
                    placeholder={m.coupon_code()}
                    className={clsx(
                    'flex-1 rounded-md border-0 py-2 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6',
                    {
                        'opacity-60 pointer-events-none': loading,
                        'ring-red-500': !!error,
                        'ring-gray-300': !error,
                    },
                    'placeholder:text-[color:var(--shop-textColor)] placeholder:opacity-60'
                    )}
                    style={{
                    color: shopVar('--shop-textColor'),
                    backgroundColor: shopVar('--shop-panelBackgroundColor'),
                      // @ts-expect-error --tw-ring-color is defined by tailwindcss
                    '--tw-ring-color': shopVar('--shop-borderColor'),
                    }}
                    value={discountCode}
                    onChange={e => setDiscountCode(e.target.value)}
                />
                {/* prevent shrinking and wrapping on the button */}
                <button
                    className={clsx(
                    'shrink-0 whitespace-nowrap rounded-md px-4 py-2',
                    {
                        'opacity-60 pointer-events-none': loading || !discountCode,
                    }
                    )}
                    style={{
                    backgroundColor: shopVar('--shop-ctaButtonColor'),
                    color: shopVar('--shop-ctaButtonTextColor'),
                    }}
                    disabled={!discountCode}
                    onClick={addDiscountCode}
                >
                    {m.add()}
                </button>
                </div>
                {error && <div className='py-2 text-red-500'>{error}</div>}
            </>
            )}
            {cart!== null && cart.appliedCouponCode !== null && (
                <div className='flex justify-between items-center'>
                    <div className=''>
                        {m.coupon_code()}: <span className='text-lg font-bold'>{cart?.appliedCouponCode?.code}</span>
                        {/* FAS-1622 — the applied code's discount, when it carries one (an unlock-only code has none) */}
                        {cart.discount !== null && (
                            <span className='ml-2 text-sm'>− {Money.fromInteger(cart.discount.totalInCents, cart.discount.currency).display(lang)}</span>
                        )}
                    </div>
                    <button className='hover:underline' onClick={() => doRemoveCoupon()}>{m.remove()}</button>
                </div>
            )}
        </div>
    );
};